import { ChangeEvent, useState, FunctionComponent, ForwardedRef, forwardRef, useEffect } from "react";
import usePlacesAutocomplete from "use-places-autocomplete";
import { useConsent } from "../../consent/useConsent";
import { loadGoogleMaps } from "../../consent/loadGoogleMaps";

interface IAutoComplete {
    name: string;
    id: string;
    type: string;
    className: string;
    placeholder: string;
    defaultValue?: string;
}
export type Ref = any;
export const AutoComplete = forwardRef<Ref, IAutoComplete>(({ name, id, type, className, placeholder, defaultValue }, ref) => {
    // Place suggestions come from Google Maps and run only with consent for
    // external media; without it this is a plain text field.
    const {
        ready,
        value,
        clearSuggestions,
        suggestions: { status, data },
        setValue,
        init
    } = usePlacesAutocomplete({ initOnMount: false });
    const { externalMediaAllowed } = useConsent();
    useEffect(() => {
        if (!externalMediaAllowed) return;
        let active = true;
        loadGoogleMaps()
            .then(() => { if (active) init(); })
            .catch((error) => console.log(error));
        return () => { active = false; };
    }, [externalMediaAllowed, init]);
    const [showPlaces, setShowPlaces] = useState(false)
    const handleInput = (e: ChangeEvent<HTMLInputElement>): void => {
        setValue(e.target.value);
        setShowPlaces(true)
    };

    const handleSelect = (val: string): void => {
        console.log(val)
        setValue(val, false);
        setShowPlaces(false)
        clearSuggestions()
    };
    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue)
        }
    }, [defaultValue])
    const renderSuggestions = (): JSX.Element => {
        const suggestions = data.map(({ place_id, description }: any) => (
            <a key={place_id} onClick={() => handleSelect(description)}>{description} </a>
        ));

        return (
            <div className="dropdown-content">
                {suggestions}
            </div>
        );
    };

    return (
        <>
            <div className="dropdown">
                <input
                    name={name}
                    id={id}
                    type={type}
                    ref={ref}
                    placeholder={placeholder}
                    className={className}
                    value={value}
                    defaultValue={defaultValue}
                    onChange={handleInput}
                ></input>
                {ready && status === "OK" && showPlaces && renderSuggestions()}
            </div>
        </>
    );
})

